var isDevice = false;
var searchActive = false;
var filtersActive = false;

(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };
})();

if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
  isDevice = true;
}

setTimeout(function () {
  var allForms = $('.inputs input');
  for (var i = 0; i < allForms.length; i++) {
    if ($(allForms[i]).val().length > 0) {
      $(allForms[i]).addClass('has-content');
    }
  }
  document.querySelectorAll('a').forEach(el => el.addEventListener('click', siteTransition));

  $('.register-button').click(function () {
    $('.nava-loader').addClass('show');
  });

}, 500);

window.siteTransition = function (e) {


  if (!e.target.classList.contains('scroll-to-btn') &&
    !e.target.classList.contains('external') &&
    !e.target.classList.contains('dont-navigate') &&
    !e.target.classList.contains('print-order-button') &&
    (e.target.getAttribute("href") != null && e.target.getAttribute("href").indexOf('#') < 0) &&
    (e.target.getAttribute("href") != null && e.target.getAttribute("href").indexOf('http') < 0) &&
    (e.target.getAttribute("href") != null && e.target.getAttribute("href").indexOf('mailto') < 0)) {

    if (e.ctrlKey || e.shiftKey || e.metaKey || (e.button && e.button == 1)) {
      console.log("Dont");
      //console.log("NEW TAB")
    } else {
      $('.nava-loader').addClass('show');
    }
  }
}

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.header').outerHeight() + $('.tools').outerHeight();
var supportPageOffset = window.pageXOffset !== undefined;
var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

$(window).on('scroll', function (event) {
  didScroll = true;
});

setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

window.hasScrolled = function () {

  var st = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

  if (Math.abs(lastScrollTop - st) <= delta)
    return;

  if (st > lastScrollTop && st > navbarHeight) {
    $('.header').removeClass('nav-down').addClass('nav-up');
    $('.breadcrumb').removeClass('nav-down').addClass('nav-up');

  } else {
    if (st + $(window).height() < $(document).height()) {
      $('.header').removeClass('nav-up').addClass('nav-down');
      $('.breadcrumb').removeClass('nav-up').addClass('nav-down');
    }
  }

  lastScrollTop = st;
}

function HideOverlay() {
  var hideOverlay = true;
  if ($('.left-menu').hasClass('active')) {
    hideOverlay = false;
  }
  if (hideOverlay) {
    $('.nava-overlay').removeClass('active');
  }
}

setTimeout(function () {
  document.querySelectorAll('.arrow-scroll-hor').forEach(el => el.addEventListener('click', scrollHorSome));

}, 600);

window.scrollToElement = function (element) {
  let foundElement = document.querySelector(element);
  if (foundElement) {
    window.scrollTo({top: foundElement.offsetTop, behavior: 'smooth'});
    setTimeout(function () {
      document.querySelector('#FullName').focus();
    }, 500);
  }
  return false;
}

window.scrollHorSome = function (e) {
  let current = e.target;
  let nextSibling = current.nextElementSibling;
  //console.log(nextSibling);

  var whatToScroll = current.nextElementSibling;

  setTimeout(function () {

    whatToScroll.scrollTo({left: 500, behavior: 'smooth'});
  }, 50);
}

var lastMenuItemId = 0;
window.ShowCategory = function (id, objClicked) {
  if (lastMenuItemId === id) {
    CloseOpenSections();
    lastMenuItemId = 0;
    $('.header').removeClass('search-active');
  } else {
    $('.header').addClass('search-active');
    $('.menu-item').removeClass('active');
    CloseAccountMenu();
    var menuContent = $('#sub-menu-id-' + id).clone();
    $('.sub-category-navigation .categories').html(menuContent);
    $('.sub-category-navigation').show();
    $(objClicked).addClass('active');
    lastMenuItemId = id;
    scroll(0, 0);

    $('.subsub-category a').click(function () {
      $('.nava-loader').addClass('show');
    });
  }
}

function CloseMenues() {
  $('.master-wrapper-page').removeClass('menu-active');
  $('.left-menu').removeClass('active');
  $('.sub-category-navigation').hide();
  $('.menu-item').removeClass('active');

  HideOverlay();
}

var customerServiceActive = false;

window.openCustomerService = function () {
  if (!customerServiceActive) {
    $('.customer-service-overlay').addClass('active');
    $('#customer-service').addClass('active');
    customerServiceActive = true;
  } else {
    $('.customer-service-overlay').removeClass('active');
    $('#customer-service').removeClass('active');
    customerServiceActive = false;
  }
}

window.RemoveItemFromShoppingCart = function (clickedElement) {
  $(clickedElement).siblings('.item-checkbox').prop('checked', true);
  $('.nava-overlay').addClass('active');
  $('.update-cart-button').click();
}

$('.quantity .qty-input').on('input', function (e) {
  var currentValue = $(e.target)[0].value;
  if (currentValue.length > 0) {
    $('.nava-overlay').addClass('active');
    $('.update-cart-button').click();
  }
});

function CloseCustomerService() {
  $('#customer-service').removeClass('active');
  $('.customer-service-overlay').removeClass('active');
}

window.CloseOpenSections = function () {
  CloseMenues();
  CloseCustomerService();
};

function CloseMenu() {
  $('.left-menu').removeClass('active');
  $('.master-wrapper-page').removeClass('menu-active');

  HideOverlay();
}

function CloseAccountMenu() {
  $('.master-wrapper-page').removeClass('menu-active');
  HideOverlay();
}

$('.top-menu a.toggle').click(function () {
  $(this).toggleClass('active');
  $(this).siblings('.sublist').toggleClass('active');
});

if (isDevice) {
  $('.item-box').bind('touchstart touchend', function (e) {
    $(this).toggleClass('mobile-hover');
  });
}

window.ToggleMenu = function () {
  if ($('.left-menu').hasClass('active')) {
    CloseMenu();
  } else {
    $('.left-menu').addClass('active');
    $('.nava-overlay').addClass('active');
  }
  HideOverlay();
}

window.ToggleSearch = function () {

  if (!searchActive) {

    $('.nava-search').addClass('show');
    $('.header').addClass('search-active');
    $('.menu-item').removeClass('active');
    $('.nava-overlay').removeClass('active');
    $('.sub-category-navigation').hide();

    document.getElementById('small-searchterms').focus();

    searchActive = true;

  } else {

    $('.nava-search').removeClass('show');
    $('.header').removeClass('search-active');

    searchActive = false;

  }
}

window.actionSearch = function () {
  $('#small-search-box-form').submit();
}

window.ToggleMobileFilters = function () {
  if (!filtersActive) {
    //console.log("ToggleMobileFilters yo");
    $('.nopAjaxFilters7Spikes').css('display', 'block');
    //TweenLite.to(window, 0.5, { scrollTo: { y: 0 }, ease: Power2.easeOut });
    filtersActive = true;

  } else {
    $('.nopAjaxFilters7Spikes').css('display', 'none');
    filtersActive = false;

  }
}

var pageTextExpanded = false;

if (document.querySelector(".category-description")) {
  var pageBodyHeight = document.querySelector(".category-description").offsetHeight;
  document.querySelector(".category-description").setAttribute('data-height', pageBodyHeight);

  if (pageBodyHeight > 80) {
    document.querySelector(".category-description-btns").classList.add("show");
    document.querySelector(".category-description").classList.add("hide");
  }
}

window.expandBodyText = function () {
  if (!pageTextExpanded) {
    document.querySelector(".category-description-btns a").innerText = "Skjul";
    document.querySelector(".category-description").classList.remove("hide");
    pageTextExpanded = true;

  } else {
    document.querySelector(".category-description-btns a").innerText = "Les mer";
    document.querySelector(".category-description").classList.add("hide");
    pageTextExpanded = false;
  }

}


if (document.querySelector(".manufacturer-description")) {
  var pageBodyHeight = document.querySelector(".manufacturer-description").offsetHeight;
  document.querySelector(".manufacturer-description").setAttribute('data-height', pageBodyHeight);

  if (pageBodyHeight > 80) {
    document.querySelector(".category-description-btns").classList.add("show");
    document.querySelector(".manufacturer-description").classList.add("hide");
  }
}

window.expandBodyManuText = function () {
  if (!pageTextExpanded) {
    document.querySelector(".category-description-btns a").innerText = "Skjul";
    document.querySelector(".manufacturer-description").classList.remove("hide");
    pageTextExpanded = true;

  } else {
    document.querySelector(".category-description-btns a").innerText = "Les mer";
    document.querySelector(".manufacturer-description").classList.add("hide");
    pageTextExpanded = false;
  }

}

document.querySelectorAll('.item-grid').forEach(el => el.addEventListener('scroll', gridScroll));

export function gridScroll() {
  var st = $(this).scrollLeft();

  if (st < 10) {
    $(this).parent().removeClass("scrolled");
  } else {
    $(this).parent().addClass("scrolled");
  }
}

window.showShipInfo = function () {
  $('.shipment-info').toggle();
}

var addToCartBtnPresent = false;

if (document.querySelector('.product-details-page') !== null) {
  setTimeout(function () {
    if (!addToCartBtnPresent) {
      //addToCartBtnPresent =true
      var addToCartBtn = document.querySelector('.add-to-cart-button');
      //console.log("knapp? " + addToCartBtn);
      document.querySelector('.loader').classList.add('done');

      if (addToCartBtn === null) {
        //console.log("no btn");
        $('.stock .value').text("Ikke tilgjengelig");
        $('.overview .nava-klarna').addClass('hide');
        $('.overview .nava-shopping-info').addClass('hide');

      }
    }
  }, 2000);
}

// GET GET DATA FROM URL
function GetURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      return decodeURIComponent(sParameterName[1]);
    }
  }
}

// ADD DATA TO URL
/*function AddDataToUrl(data) {
  // Get the current URL and query string
  var currentUrl = window.location.href;
  var currentQueryString = window.location.search;

  // Add the new parameter to the query string
  var newParameter = data;
  var newQueryString = currentQueryString ? currentQueryString + '&' + newParameter : '?' + newParameter;
  

  // Set the new URL with the updated query string
  window.location.href = currentUrl + newQueryString;
}*/
function AddDataToUrl(name, value) {
  // Get the current URL and query string
  var url = new URL(window.location.href);
  var searchParams = new URLSearchParams(url.search);
  // Update or add the parameter
  if (searchParams.has(name)) {
    searchParams.set(name, value);
  } else {
    searchParams.append(name, value);
  }
  if (!value) {
    searchParams.delete(name)
  }

  var queryString = searchParams.toString().replace(/\+/g, '%20');

  // Create a new URL with the updated query string
  var newUrl = url.origin + url.pathname + '?' + queryString;

  // Update the URL without refreshing the page
  history.pushState({path: newUrl}, '', newUrl);
}

// TECDOC CODE BELOW

var ranManu = false;
var ManuId = 0;
var carId = 0;
var rmi = false;
var regnr = "";
var oeNum = "";
var filterused = 0;
var qualId = 0;
var mainGroupId = 0;
var subGroupId = 0;
var itemId = 0;

if ($('.html-tecdoc-page').length) {
  // RESTORE WHEN GOING BACK ONE PAGE USING GET DATA :D
  $(document).ready(function () {
    carId = GetURLParameter("carid");
    regnr = GetURLParameter("regnr");
    rmi = GetURLParameter("rmi");
    oeNum = GetURLParameter("oeNum");
    qualId = GetURLParameter("qualid");
    var catId = GetURLParameter("catid");
    if (carId) {
      if (rmi) {
        var endpoint = "/TecDoc/GetCarNameByCarRMIId/" + carId;
      } else {
        var endpoint = "/TecDoc/GetCarNameByCarId/" + carId;
      }
      $.ajax({
        url: endpoint,
        type: "GET",
        success: function (data) {
          if (!data.rmi) {
            var carname = $(data);
            $('.carname').prepend(carname.filter('p'))
            $('.carname').append(carname.filter('span'))
            $('.regnr-js').html(regnr)
            $('.carname').addClass('show');
            if (regnr) {
              $.ajax({
                url: "/SVV/GetCarDetails/" + regnr,
                type: "GET",
                success: function (data) {
                  $('.cardetails').append(data)
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No vegvesen Content');
                  }
                }
              });
            }
          }
          if (data.rmi && data.multipleQual && (qualId === 0 || qualId === undefined)) {
            $('#tecdocProducts').html(data.view)
            rmi = true;
            carId = data.carid;
            var carname = $(data.CarDetails);
            $('.carname').prepend(carname.filter('p'))
            $('.carname').append(carname.filter('span'))
            $('.regnr-js').html(regnr)
            $('.carname').addClass('show');
            if (regnr) {
              $.ajax({
                url: "/SVV/GetCarDetails/" + regnr,
                type: "GET",
                success: function (data) {
                  $('.cardetails').append(data)
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No vegvesen Content');
                  }
                }
              });
            }
            AddDataToUrl('rmi', "true");
            var regNr = $('input.regnr').val();
            AddDataToUrl('regnr', regNr);
            AddDataToUrl('carid', carId);
          }
          if (data.rmi && !data.multipleQual) {
            rmi = true;
            var carname = $(data.CarDetails);
            $('.carname').prepend(carname.filter('p'))
            $('.carname').append(carname.filter('span'))
            $('.regnr-js').html(regnr)
            $('.carname').addClass('show');
            if (regnr) {
              $.ajax({
                url: "/SVV/GetCarDetails/" + regnr,
                type: "GET",
                success: function (data) {
                  $('.cardetails').append(data)
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No vegvesen Content');
                  }
                }
              });
            }
            AddDataToUrl('qualid', qualId);
            $('body').append('<div class="loading-tecdoc"></div>')
            $.ajax({
              url: "/TecdocRMI/GetVehicleImage/" + qualId + "/" + carId,
              type: "GET",
              success: function (data) {
                $('.loading-tecdoc').remove();
                $('#tecdocProducts').html(data.viewCar)
                $('#tecdocCats').html(data.viewCat)
                $('#tecdocCats').removeClass('no-content')
                $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
                setupTecDocMenu();
                // TECDOC RÆL KODE
                InitilizeTecdocRMIJS();
              }
            });
          }
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
          $('.loading-tecdoc').remove();
        },
        statusCode: {
          204: function () {
            console.log('No name found');
            $('.loading-tecdoc').remove();
          }
        }
      });
      if (!rmi) {
        $('body').append('<div class="loading-tecdoc"></div>')
        $.ajax({
          url: "/TecDoc/GetCategoriesByCarId/" + carId + "/0/false",
          type: "GET",
          success: function (data) {
            $('#tecdocCats').html(data)
            $('#tecdocCats').removeClass('no-content')

            if (catId) {
              $.ajax({
                url: "/TecDoc/GetCategoriesByCarId/" + carId + "/" + catId + "/true",
                type: "GET",
                success: function (data) {
                  $('#tecdocProducts').html(data)
                  $('.loading-tecdoc').remove();
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No Tecdoc Content');
                    $('.loading-tecdoc').remove();
                  }
                }
              });
            } else {
              $('.loading-tecdoc').remove();
            }
            $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
            setupTecDocMenu();
          },
          error: function (xhr, textStatus, errorThrown) {
            console.error("Error getting data from endpoint: " + errorThrown);
          },
          statusCode: {
            204: function () {
              console.log('No Tecdoc Content');
            }
          }
        })
      }
    } else {
      var entries = JSON.parse(localStorage.getItem('regnrs')) || [];
      var lastEntries = entries.slice(Math.max(entries.length - 10, 0));
      if (lastEntries.length != 0) {
        $('.prev-regnr').addClass('show');
      }
      lastEntries.forEach(function (cars, index) {
        var text = "";
        if (cars.rmi) {
          text = "&rmi=true"
        }
        $('.prev-regnr').append(
          '<div class="regnr-single">' +
          '<a class="goto-car" href="?carid=' + cars.carid + '&regnr=' + cars.regnr + '' + text +'"><span class="regnr">' + cars.regnr + '</span>' +
          '<span class="name">&nbsp;-&nbsp;' + cars.name + '</span></a>' +
          '</div>'
        )
      });
    }

    if (oeNum) {
      $('body').append('<div class="loading-tecdoc"></div>')
      $.ajax({
        url: "/TecDoc/OEM/" + oeNum,
        type: "GET",
        success: function (data) {
          $('.tecdoc.auto').hide();
          $('.tecdoc.oem').show();
          $('input.oem').val(oeNum);
          $('#tecdocProducts').html(data)
          $('.loading-tecdoc').remove();
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.loading-tecdoc').remove();
          }
        }
      });
    }
  });

  $(document).on('click', '.switchtomanu', function () {
    $('#tecdocProducts').html("");
    AddDataToUrl('oeNum', "");
    AddDataToUrl('regnr', "");
    AddDataToUrl('carid', "");
    $('.manual').show();
    $('.auto').hide();
    $('.oem').hide();
    if (ranManu != true) {
      $('body').append('<div class="loading-tecdoc"></div>')
      $.ajax({
        url: "/TecDoc/GetManufacture",
        type: "GET",
        success: function (data) {
          $('#filter1').append(data)
          $('.loading-tecdoc').remove();
          ranManu = true;
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
          }
        }
      });
    }
    //filter1 Populate filter1
  })

  $("#filter1").change(function () {
    $('body').append('<div class="loading-tecdoc"></div>')
    if ($(this).val() != "0") {
      ManuId = $(this).val();
      $.ajax({
        url: "/TecDoc/GetModelSeries/" + $(this).val(),
        type: "GET",
        success: function (data) {
          $('#filter2').html('<option value="0">Velg</option>')
          $('#filter2').append(data)
          $('.loading-tecdoc').remove();
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
          }
        }
      });
    }
  })

  $("#filter2").change(function () {
    $('body').append('<div class="loading-tecdoc"></div>')
    if ($(this).val() != "0") {
      var ModelId = $(this).val();
      $.ajax({
        url: "/TecDoc/GetMotorSeries/" + ManuId + "/" + ModelId,
        type: "GET",
        success: function (data) {
          $('#filter3').html('<option value="0">Velg</option>')
          $('#filter3').append(data)
          $('.loading-tecdoc').remove();
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
          }
        }
      });
    }
  })

  $("#filter3").change(function () {
    $('body').append('<div class="loading-tecdoc"></div>')
    if ($(this).val() != "0") {
      carId = $(this).val();
      filterused = $(this).val();
      AddDataToUrl('carid', carId);
      $.ajax({
        url: "/TecDoc/GetRmiByFilterChoice/" + carId,
        type: "GET",
        success: function (data) {
          console.log(data)
          if (!data.rmi) {
            $.ajax({
              url: "/TecDoc/GetCategoriesByCarId/" + carId + "/0/false",
              type: "GET",
              success: function (data) {
                $('#tecdocCats').html(data)
                $('#tecdocCats').removeClass('no-content')

                $('.product-grid').html("");
                $('.loading-tecdoc').remove();
                $('.snowmobile-option-wrapper.manual').addClass("hide");
                setupTecDocMenu();
                $.ajax({
                  url: "/TecDoc/GetCarNameByCarId/" + carId,
                  type: "GET",
                  success: function (data) {
                    var carname = $(data);
                    if ($('.carname p').length == 0) {
                      $('.carname').prepend(carname.filter('p'))
                      $('.carname').append(carname.filter('span'))
                    } else {
                      $('.carname p').html(carname.filter('p'))
                      $('.carname span').html(carname.filter('span'))
                    }

                    $('.regnr-js').html("Ingen")
                    $('.carname').addClass('show');
                  },
                  error: function (xhr, textStatus, errorThrown) {
                    console.error("Error getting data from endpoint: " + errorThrown);
                  },
                  statusCode: {
                    204: function () {
                      console.log('No name found');
                    }
                  }
                });
              },
              error: function (xhr, textStatus, errorThrown) {
                console.error("Error getting data from endpoint: " + errorThrown);
              },
              statusCode: {
                204: function () {
                  console.log('No Tecdoc Content');
                  $('.carname').removeClass('show');
                  $('.snowmobile-option-wrapper.manual').removeClass("hide");
                }
              }
            });
          }
          if (data.rmi && data.multipleQual) {
            $('.loading-tecdoc').remove();
            $('.tecdoc.manual').after(data.view)
            carId = data.carid;
            AddDataToUrl('rmi', "true");
            var regNr = $('input.regnr').val();
            AddDataToUrl('regnr', regNr);
            AddDataToUrl('carid', carId);
          }
          if (data.rmi && !data.multipleQual) {
            carId = data.carid;
            AddDataToUrl('rmi', "true");
            var regNr = $('input.regnr').val();
            AddDataToUrl('regnr', regNr);
            AddDataToUrl('carid', carId);
            AddDataToUrl('qualid', data.qualId);
            var carname = $(data.CarDetails);
            if ($('.carname p').length == 0) {
              $('.carname').prepend(carname.filter('p'))
              $('.carname').append(carname.filter('span'))
            } else {
              $('.carname p').html(carname.filter('p'))
              $('.carname span').html(carname.filter('span'))
            }
            $('.regnr-js').html("Ingen")
            $('.carname').addClass('show');
            $.ajax({
              url: "/TecdocRMI/GetVehicleImage/" + data.qualId + "/" + carId,
              type: "GET",
              success: function (data) {
                $('.loading-tecdoc').remove();
                $('#tecdocProducts').html(data.viewCar)
                $('#tecdocCats').html(data.viewCat)
                $('#tecdocCats').removeClass('no-content')

                $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
                setupTecDocMenu();
                // TECDOC RÆL KODE
                InitilizeTecdocRMIJS();
              }
            });
          }
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.carname').removeClass('show');
            $('.snowmobile-option-wrapper.manual').removeClass("hide");
            $('.loading-tecdoc').remove();
            $('.option-wrapper').children('.error').html('Fant ikke kjøretøy');
            $('.select-option').addClass('not-found');

            setTimeout(function () {
              $('.select-option').removeClass('not-found');
            }, 1000);
          }
        }
      });
    }
  })

  $(document).on('click', '.edit-car', function (e) {
    if (filterused != 0) {
      e.preventDefault();
      $('.tecdoc.manual').removeClass("hide");
    }
  })

  $(document).on('click', '.car-details', function () {
    $('.cardetails').toggleClass('show');
    if ($('.cardetails').is(':hidden')) {
      $('.car-details').html('Se detaljer')
    } else {
      $('.car-details').html('Gjem detaljer')
    }
  })

  $(document).on('submit', '.oem', function (e) {
    e.preventDefault()
    $('body').append('<div class="loading-tecdoc"></div>')
    if ($('input.oem').val() != "") {
      AddDataToUrl('oeNum', $('input.oem').val());
      $.ajax({
        url: "/TecDoc/OEM/" + $('input.oem').val(),
        type: "GET",
        success: function (data) {
          $('.option-wrapper').children('.error').html('');
          $('#tecdocProducts').html(data)
          $('.loading-tecdoc').remove();
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.loading-tecdoc').remove();
            $('.option-wrapper').children('.error').html('Fant ikke produkter på det OEM nummeret');
            $('.select-option').addClass('not-found');

            setTimeout(function () {
              $('.select-option').removeClass('not-found');
            }, 1000);
          }
        }
      });
    } else {
      $('.loading-tecdoc').remove();
    }
  })

  $(document).on('submit', '.regnr', function (e) {
    e.preventDefault()
    $('body').append('<div class="loading-tecdoc"></div>')
    if ($('input.regnr').val() != "") {
      $.ajax({
        url: "/TecDoc/GetIdByReg/" + $('input.regnr').val(),
        type: "GET",
        success: function (data) {
          console.log(data)
          if (!data.rmi) {
            var cardetails = $(data.view);
            $('.carname').prepend(cardetails.filter('p'))
            $('.carname').append(cardetails.filter('span'))
            $('.carname').append(cardetails.filter('input'))
            $('.regnr-js').html($('input.regnr').val())
            $.ajax({
              url: "/SVV/GetCarDetails/" + $('input.regnr').val(),
              type: "GET",
              success: function (data) {
                console.log(data)
                $('.cardetails').append(data)
              },
              error: function (xhr, textStatus, errorThrown) {
                console.error("Error getting data from endpoint: " + errorThrown);
              },
              statusCode: {
                204: function () {
                  console.log('No vegvesen Content');
                }
              }
            });
            $('.carname').addClass('show');
            carId = $('.carId').val();
            if (carId) {
              var inputValue = $('input.regnr').val();
              var entries = JSON.parse(localStorage.getItem('regnrs')) || [];
              var newEntry = {
                rmi: false,
                regnr: inputValue,
                carid: carId,
                name: cardetails.filter('p').text()
              };
              entries.push(newEntry);
              if (entries.length > 20) {
                entries.shift();
              }
              localStorage.setItem('regnrs', JSON.stringify(entries));

              AddDataToUrl('carid', carId);
              AddDataToUrl('regnr', inputValue);
              $('.carname').addClass('show');
              $.ajax({
                url: "/TecDoc/GetCategoriesByCarId/" + carId + "/0/false",
                type: "GET",
                success: function (data) {
                  $('#tecdocCats').html(data)
                  $('#tecdocCats').removeClass('no-content')

                  $('.loading-tecdoc').remove();
                  setupTecDocMenu();
                  $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No Tecdoc Content');
                  }
                }
              });
            }
          }
          if (data.rmi && data.multipleQual) {
            $('.loading-tecdoc').remove();
            $('.tecdoc .option-wrapper form.regnr').after(data.view)
            carId = data.carid;

            regnr = $('input.regnr').val();
            var carname = $(data.CarDetails);
            $('.carname').prepend(carname.filter('p'))
            $('.carname').append(carname.filter('span'))
            $('.regnr-js').html(regnr)
            
            var entries = JSON.parse(localStorage.getItem('regnrs')) || [];
            var newEntry = {
              rmi: true,
              regnr: regnr,
              carid: carId,
              name: carname.filter('p').text()
            };
            entries.push(newEntry);
            if (entries.length > 20) {
              entries.shift();
            }
            localStorage.setItem('regnrs', JSON.stringify(entries));
            
            $('.carname').addClass('show');
            if (regnr) {
              $.ajax({
                url: "/SVV/GetCarDetails/" + regnr,
                type: "GET",
                success: function (data) {
                  $('.cardetails').append(data)
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No vegvesen Content');
                  }
                }
              });
            }
            AddDataToUrl('rmi', "true");
            var regNr = $('input.regnr').val();
            AddDataToUrl('regnr', regNr);
            AddDataToUrl('carid', carId);
          }
          if (data.rmi && !data.multipleQual) {
            carId = data.carid;
            regnr = $('input.regnr').val();
            AddDataToUrl('rmi', "true");
            var regNr = $('input.regnr').val();
            var carname = $(data.CarDetails);
            $('.carname').prepend(carname.filter('p'))
            $('.carname').append(carname.filter('span'))
            $('.regnr-js').html(regnr)
            var entries = JSON.parse(localStorage.getItem('regnrs')) || [];
            var newEntry = {
              rmi: true,
              regnr: regnr,
              carid: carId,
              name: carname.filter('p').text()
            };
            entries.push(newEntry);
            if (entries.length > 20) {
              entries.shift();
            }
            localStorage.setItem('regnrs', JSON.stringify(entries));
            $('.carname').addClass('show');
            if (regnr) {
              $.ajax({
                url: "/SVV/GetCarDetails/" + regnr,
                type: "GET",
                success: function (data) {
                  $('.cardetails').append(data)
                },
                error: function (xhr, textStatus, errorThrown) {
                  console.error("Error getting data from endpoint: " + errorThrown);
                },
                statusCode: {
                  204: function () {
                    console.log('No vegvesen Content');
                  }
                }
              });
            }
            AddDataToUrl('regnr', regNr);
            AddDataToUrl('carid', carId);
            AddDataToUrl('qualid', data.qualId);
            $.ajax({
              url: "/TecdocRMI/GetVehicleImage/" + data.qualId + "/" + carId,
              type: "GET",
              success: function (data) {
                $('.loading-tecdoc').remove();
                $('#tecdocProducts').html(data.viewCar)
                $('#tecdocCats').html(data.viewCat)
                $('#tecdocCats').removeClass('no-content')

                $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
                setupTecDocMenu();
                // TECDOC RÆL KODE
                InitilizeTecdocRMIJS();
              }
            });
          }
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.carname').removeClass('show');
            $('.snowmobile-option-wrapper.manual').removeClass("hide");
            $('.loading-tecdoc').remove();
            $('.option-wrapper').children('.error').html('Fant ikke kjøretøy');
            $('.select-option').addClass('not-found');

            setTimeout(function () {
              $('.select-option').removeClass('not-found');
            }, 1000);
          }
        }
      });
    } else {
      $('.loading-tecdoc').remove();
    }
  })

  $(document).on('click', '.choose-qual .choose_button a', function () {
    qualId = $(this).attr('data-qualid');
    $('body').append('<div class="loading-tecdoc"></div>')
    $.ajax({
      url: "/TecdocRMI/GetVehicleImage/" + qualId + "/" + carId,
      type: "GET",
      success: function (data) {
        AddDataToUrl('qualid', qualId);
        $('.loading-tecdoc').remove();
        $('#tecdocProducts').html(data.viewCar)
        $('#tecdocCats').html(data.viewCat)
        $('#tecdocCats').removeClass('no-content')

        $('.snowmobile-option-wrapper.tecdoc').addClass('hide');
        setupTecDocMenu();
        // TECDOC RÆL KODE
        InitilizeTecdocRMIJS();
      }
    });
    console.log(qualId)
  })

  $(document).on('click', '.top-menu.rmi a', function () {
    $('body').append('<div class="loading-tecdoc"></div>')

    let subid = $(this).attr('data-backsubid');
    if ($(this).attr('data-id')) {
      mainGroupId = $(this).attr('data-id');
      AddDataToUrl('mainGroupId', mainGroupId);
      
      $.ajax({
        url: "/TecdocRMI/GetMainGroupImg/" + qualId + "/" + carId + "/" + mainGroupId,
        type: "GET",
        success: function (data) {
          if ($("#prevImg .carImg").length == 0) {
            $("#prevImg").show()
            $("#prevImg").html("<div class='carImg'></div>")
          }
          
          if (!subid) {
            $("#prevImg .carImg").html($('#tecdocProducts svg').html());
            $("#prevImg .carImg").children().css('display', 'none');
            $("#prevImg .carImg img").attr('src', $("#prevImg .carImg img").attr('xlink:href'));
            $("#prevImg .carImg img").css('display', 'block');
            $("#prevImg .carImg img").css('height', '100%');
          }
          
          $("#prevImg").attr('data-carId', carId);
          $("#prevImg").attr('data-qualId', qualId);
          
          $('#tecdocProducts').html(data.viewCar)
          $('#tecdocProducts > *').addClass('showingMainGroup')
          $('.loading-tecdoc').remove();
          $(".maingroupImg").hide();
          $(".subImg").hide();
          $(".carImg").show();
        }
      });
    } else if ($(this).attr('data-subid')) {
      subGroupId = $(this).attr('data-subid');
      AddDataToUrl('subGroupId', subGroupId);
      
      $.ajax({
        url: "/TecdocRMI/GetSubGroupImg/" + qualId + "/" + carId + "/" + mainGroupId + "/" + subGroupId,
        type: "GET",
        success: function (data) {
          if ($("#prevImg .maingroupImg").length == 0) {
            $("#prevImg").append("<div class='maingroupImg'></div>")
          }

          $("#prevImg .maingroupImg").html($('#tecdocProducts svg').html());

          $("#prevImg .maingroupImg").children().css('display', 'none');
          $("#prevImg .maingroupImg img").attr('src', $("#prevImg .maingroupImg img").attr('xlink:href'));
          $("#prevImg .maingroupImg img").css('display', 'block');
          $("#prevImg .maingroupImg g").css('display', 'block');
          $("#prevImg .maingroupImg img").css('height', '100%');
          if ($('#tecdocProducts svg g *').attr("transform")) {
            let transform = $('#tecdocProducts svg g *').attr("transform");
            let values = transform.match(/-?\d+(\.\d+)?/g);
            values.pop();
            let tranformValue = 'matrix(' + values.join(', ') + ', 0)';
            $("#prevImg .maingroupImg img").css("transform", tranformValue);
          }
          $(".maingroupImg").show();
          $("#prevImg").attr('mainGroupId', mainGroupId);
          
          $('#tecdocProducts').html(data.viewCar)
          $('#tecdocProducts > *').addClass('showingSubGroup')
          $('.loading-tecdoc').remove();
          $(".maingroupImg").show();
          $(".subImg").hide();
          $(".carImg").hide();
        }
      });
    } else if ($(this).attr('data-itemid')) {
      $(".maingroupImg").hide();
      $(".carImg").hide();
      itemId = $(this).attr('data-itemid');
      AddDataToUrl('itemId', itemId);
      if ($("#prevImg .subImg").length == 0) {
        $("#prevImg").append("<svg class='subImg'></svg>");
      }
      $("#prevImg svg").css('pointer-events', 'none');
      $("#prevImg svg").html($('#tecdocProducts svg').html());
      $("#prevImg svg").css('display', 'block');
      $("#prevImg svg").css('height', '100%');
      $("#prevImg").attr('subGroupId', subGroupId);
      $("#prevImg svg").attr("viewBox", "0 0 566.93 425.2");

      $.ajax({
        url: "/TecdocRMI/GetProducts/" + qualId + "/" + carId + "/" + mainGroupId + "/" + subGroupId + "/" + itemId,
        type: "GET",
        success: function (data) {
          $('.loading-tecdoc').remove();
          $('#tecdocProducts').html(data.viewCar)
          $('#tecdocProducts > *').addClass('showingProducts')
          AddDataToUrl('itemId', itemId);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.loading-tecdoc').remove();
          }
        }
      });
    } else {
      $.ajax({
        url: "/TecdocRMI/GetVehicleImage/" + qualId + "/" + carId,
        type: "GET",
        success: function (data) {          
          $('#tecdocProducts').html(data.viewCar)
          $('.loading-tecdoc').remove();
          $(".maingroupImg").remove();
          $(".subImg").remove();
          $(".carImg").remove();
          $("#prevImg").hide()
        }
      });
    }
  })
  
  $(document).on('click', '.tecdoc li > a > span', function () {
    $('body').append('<div class="loading-tecdoc"></div>')
    var thisLi = $(this).parent().parent();
    AddDataToUrl('catid', thisLi.attr('data-id'));
    if (thisLi.attr('data-id') != "0") {
      var last = true;

      $.ajax({
        url: "/TecDoc/GetCategoriesByCarId/" + carId + "/" + thisLi.attr('data-id') + "/" + last,
        type: "GET",
        success: function (data) {
          if (last) {
            $('#tecdocProducts').html(data)
          }
          $('.loading-tecdoc').remove();

          let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1023px)');
          if (mobile.matches) {
            console.log("scroll to products");
            var $scrollToProds = $('#tecdocProducts');
            $("html, body").animate({scrollTop: $scrollToProds.offset().top}, 300);
          }

        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
            console.log('No Tecdoc Content');
            $('.loading-tecdoc').remove();
          }
        }
      });
    }
  })

  $(document).on('click', '.switchtoauto', function () {
    $('#tecdocProducts').html("");
    AddDataToUrl('oeNum', "");
    AddDataToUrl('regnr', "");
    AddDataToUrl('carid', "");
    $('.manual').hide();
    $('.auto').show();
    $('.oem').hide();
  })
  $(document).on('click', '.switchtooem', function () {
    AddDataToUrl('oeNum', "");
    AddDataToUrl('regnr', "");
    AddDataToUrl('carid', "");
    $('#tecdocProducts').html("");
    $('.manual').hide();
    $('.auto').hide();
    $('.oem').show();
  })
}

$(document).ready(function () {
  var sku = $('.product-details-tecdoc input').val();
  $.ajax({
    url: "/TecDoc/GetArticleDetails/" + sku,
    type: "GET",
    success: function (data) {
      $('.product-details-tecdoc').html(data)
    },
    error: function (xhr, textStatus, errorThrown) {
      console.error("Error getting data from endpoint: " + errorThrown);
    },
    statusCode: {
      204: function () {
        console.log('No Tecdoc Content');
      }
    }
  });
})


$(document).on('click', '#prevImg', function () {
  if ($("#tecdocProducts .graphic-search").hasClass("showingSubGroup") || $("#tecdocProducts .products").length > 0 || $("#tecdocProducts .graphic-search").hasClass("showingMainGroup")) {
    $('body').append('<div class="loading-tecdoc"></div>')
    
    carId = GetURLParameter("carid");
    qualId = GetURLParameter("qualid");
    mainGroupId = GetURLParameter("mainGroupId");
    subGroupId = GetURLParameter("subGroupId");
    itemId = GetURLParameter("itemId");
    console.log($(this))
    if ($("#tecdocProducts .products").length > 0) {
      $.ajax({
        url: "/TecdocRMI/GetSubGroupImg/" + qualId + "/" + carId + "/" + mainGroupId + "/" + subGroupId,
        type: "GET",
        success: function (data) {
          $(".maingroupImg").show();
          $(".subImg").hide();
          $('.loading-tecdoc').remove();
          $('#tecdocProducts').html(data.viewCar)
          console.log("Add the class please")
          $('#tecdocProducts > *').addClass('showingSubGroup')
          AddDataToUrl('subGroupId', subGroupId);
        }
      });
    } else if ($("#tecdocProducts .graphic-search").hasClass("showingSubGroup")) {
      let elem = document.querySelector('#tecdocCats .goback-level1 a[data-backsubid="' + subGroupId + '"]');
      customMenuBackWithElem(elem);
      $.ajax({
        url: "/TecdocRMI/GetMainGroupImg/" + qualId + "/" + carId + "/" + mainGroupId,
        type: "GET",
        success: function (data) {
          $('.loading-tecdoc').remove();
          $(".maingroupImg").hide();
          $(".subImg").hide();
          $(".carImg").show();
          $("#prevImg image").data("qualId", qualId).data("carId", carId);
          $('#tecdocProducts').html(data.viewCar)
          $('#tecdocProducts > *').addClass('showingMainGroup')
          AddDataToUrl('mainGroupId', mainGroupId);
        }
      });
    } else if ($("#tecdocProducts .graphic-search").hasClass("showingMainGroup")) {
      let elem = document.querySelector('#tecdocCats .goback-level0 a[data-backid="' + mainGroupId + '"]');
      customMenuBackWithElem(elem);
      $.ajax({
        url: "/TecdocRMI/GetVehicleImage/" + qualId + "/" + carId,
        type: "GET",
        success: function (data) {
          $('.loading-tecdoc').remove();
          $('#tecdocProducts').html(data.viewCar)
          /*$('#tecdocCats').html(data.viewCat)*/
          $(".maingroupImg").remove();
          $(".subImg").remove();
          $(".carImg").remove();
          $("#prevImg").hide();
        }
      });
    }
  }
});

$(function () {
  if ($('.html-product-details-page').length) {
    var sku = $('.sku span[itemprop="sku"]').html();
    $.ajax({
      url: "/Tecdoc/GetTecdocImgBySku/" + sku,
      type: "GET",
      success: function (data) {
        $('.gallery.sevenspikes-cloudzoom-gallery').html(data)
        $.getScript('/Plugins/SevenSpikes.Nop.Plugins.CloudZoom/Scripts/CloudZoom.min.js');
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error("Error getting data from endpoint: " + errorThrown);
      },
      statusCode: {
        204: function () {
          console.log('No Tecdoc Content');
        }
      }
    });
  }
})

$(function () {
  if ($('.html-product-details-page').length) {
    var sku = $('.sku span[itemprop="sku"]').html();
    $.ajax({
      url: "/Tecdoc/GetMandatoryInfoBySku/" + sku,
      type: "GET",
      success: function (data) {
        $('.tecdoc-details').html(data)
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error("Error getting data from endpoint: " + errorThrown);
      },
      statusCode: {
        204: function () {
          console.log('No Tecdoc Content');
        }
      }
    });
  }
});


let mobile = window.matchMedia('(min-width: 0px) and (max-width: 1399px)');


window.toggleNav = function () {
  var mainBody = document.getElementsByTagName("body")[0];

  if (mainBody.classList.contains('menu-active')) {

    document.querySelectorAll('.top-menu .level0.has-children > a').forEach((f) => {
      f.classList.remove('active');
      f.classList.remove('expanded');
      f.classList.remove('fade-down');
    });

    document.querySelectorAll('.sublist').forEach((f) => {
      f.classList.remove('active');
    });

    document.querySelectorAll('.top-menu .slide-left').forEach(el => el.classList.remove('slide-left'));
    document.querySelectorAll('.top-menu .active').forEach(el => el.classList.remove('active'));

    mainBody.classList.remove("menu-active");
    mainBody.classList.add("menu-not-active");

  } else {
    mainBody.classList.add("menu-active");
    mainBody.classList.remove("menu-not-active");
  }

  document.querySelectorAll('.slide-left').forEach(el => el.classList.remove('slide-left'));
};


function customMenuBackWithElem(elem) {
  let level = elem.dataset.menuLevel;
  elem.parentElement.parentElement.classList.toggle('active');
  document.querySelectorAll(`.top-menu .level${level}.slide-left`).forEach(el => el.classList.remove('slide-left'));
  document.querySelectorAll(`.top-menu .goback-level${level - 1}.slide-left`).forEach(el => el.classList.remove('slide-left'));

  elem.parentElement.classList.toggle('slide-left');
  elem.parentElement.parentElement.parentElement.classList.toggle('active');
  elem.parentElement.parentElement.parentElement.querySelector('.menu-item.toggle').classList.toggle('active');
}

function customMenuClick() {
  let level = this.dataset.menuLevel;
  console.log(level)
  // console.log("customMenuClick: " + level);

  //if (mobile.matches) {
  // MOBILE MENU
  this.classList.toggle('active');
  this.parentElement.classList.toggle('active');

  document.querySelectorAll(`.top-menu .level${level}:not(.active)`).forEach(el => el.classList.toggle('slide-left'));
  document.querySelectorAll(`.top-menu .goback-level${level - 1}`).forEach(el => el.classList.toggle('slide-left'));

  if (this.nextElementSibling) {
    this.nextElementSibling.classList.toggle('active');
  }

  if (level == 0) {
    document.querySelectorAll(`.top-menu .goback-level0`).forEach(el => el.classList.remove('slide-left'));

    var $scrollToProds = $('#tecdocCats');
    //$("html, body").animate({scrollTop: $scrollToProds.offset().top}, 300);
  }

  if (level == 1) {
    document.querySelectorAll(`.top-menu .goback-level1`).forEach(el => el.classList.remove('slide-left'));
  }

  //}

}

function customMenuBack() {
  let level = this.dataset.menuLevel;
  this.parentElement.parentElement.classList.toggle('active');
  document.querySelectorAll(`.top-menu .level${level}.slide-left`).forEach(el => el.classList.remove('slide-left'));
  document.querySelectorAll(`.top-menu .goback-level${level - 1}.slide-left`).forEach(el => el.classList.remove('slide-left'));

  this.parentElement.classList.toggle('slide-left');
  this.parentElement.parentElement.parentElement.classList.toggle('active');
  this.parentElement.parentElement.parentElement.querySelector('.menu-item.toggle').classList.toggle('active');
}

function setupTecDocMenu() {
  console.log("setupTecDocMenu");
  document.querySelectorAll('.top-menu a.toggle').forEach(el => el.addEventListener('click', customMenuClick));
  document.querySelectorAll('.top-menu a.menu-goback').forEach(el => el.addEventListener('click', customMenuBack));
}

function InitilizeTecdocRMIJS() {
  var showError = false;
  window.onresize = function () {
    resizeSVG();
  };
  let i;
  resizeSVG();
  try {
    let disabledElements = document.getElementsByClassName('disabled');
    for (i = 0; i < disabledElements.length; i++) {
      disabledElements[i].childNodes[1].attributes.opacity.value = '0.3';
      disabledElements[i].childNodes[1].attributes.fill.value = '#CCC';
    }
  } catch (e) {
    if (showError)
      alert(emsg + e);
  }
}

$(document).ready(function () {
  if ($('.search-result')) {
    let element = document.querySelectorAll('.item-box:not(.tecdoc-loaded)');
    element.forEach(function (e) {
      let sku = $(e).find('.sku').html();
      $.ajax({
        url: "/Tecdoc/GetTecdocImgUrlBySku/" + sku,
        type: "GET",
        success: function (data) {
          if (typeof data !== 'undefined') {
            $(e).find('.picture-center img').attr("src", data);
          }
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
          }
        }
      });
    });

    element.forEach(function (e) {
      let sku = $(e).find('.sku').html();
      $.ajax({
        url: "/Tecdoc/GetMandatoryInfoBySku/" + sku,
        type: "GET",
        success: function (data) {
          $(e).find('.mandatory-infos').html(data)
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
          }
        }
      });
    });

    element.forEach(function (e) {
      let sku = $(e).find('.sku').html();
      $.ajax({
        url: "/Tecdoc/GetTitleBySku/" + sku,
        type: "GET",
        success: function (data) {
          if (data !== undefined) {
            let oldTitle = $(e).find('.product-title').html()
            $(e).find('.product-title').html(data + "(" + oldTitle + ")")
          }
        },
        error: function (xhr, textStatus, errorThrown) {
          console.error("Error getting data from endpoint: " + errorThrown);
        },
        statusCode: {
          204: function () {
          }
        }
      });
    });
    element.forEach(function (e) {
      e.classList.add('tecdoc-loaded');
    });
  }
});
